import { Button, Col, Drawer, Form, Input, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useState } from 'react';
import { createRoles, editRoles } from '../../../../../../api';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from '../../../../../../components/message';
import closeIcon from '../../../../../../assets/svg/close-icon.svg';
import roleEditIcon from '../../../../../../assets/svg/role-edit-icon.svg';
import roleEditIconHover from '../../../../../../assets/svg/role-edit-icon-hover.svg';
// import { getLangFormatText, LanguageType } from '../../../../../../lib';
import getFormatMessage from '../../../../../../locales/get-format-message';
import './index.scss';
import {
  RolesDrawerType,
  IRBACRole,
  IServicePermissions,
  RbacRoleType,
  RbacRoleObjectKey,
} from '../../../../../../model/rbac';
import { AccessRights } from './access-rights';
import classNames from 'classnames';
import { PermissionCheck } from '../../../../../component/permission-check';
import { ISystemMenuItem } from '../../../../../../model/system/menu';
import { getServiceList } from '../../../../../../api/services';
import { convert2Menu } from '../../../../../game-content/lib';
import { auditWriteLog } from '../../../../../lib/aduit-log';
import { IAuditItem } from '../../../../../../model/api-modules';

interface IProps {
  readonly onClose: (status?: boolean) => void;
  readonly type: RolesDrawerType;
  readonly currentRecord: IRBACRole | null;
  readonly studioId: string;
  readonly onUpdate: () => void;
  readonly permissionsList: IServicePermissions | null;
  readonly setEditType: (value: RolesDrawerType) => void;
}

export const RolesDrawer = (props: IProps) => {
  const [form] = useForm<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]); // 存储选中的选项
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [menus, setMenus] = useState<ISystemMenuItem[]>([]);

  useEffect(() => {
    queryServiceConfigList();
  }, []);

  const queryServiceConfigList = async () => {
    const data = await getServiceList();
    const convertMenu = convert2Menu(data || []);
    const currentMenu: ISystemMenuItem[] = [];
    convertMenu.forEach((item) => {
      if (item?.subMenus?.length !== 0) {
        item.subMenus?.forEach((it) => {
          currentMenu.push(it);
        });
      }
    });
    setMenus(currentMenu || []);
  };

  const getModalTitle = () => {
    if (props.type === RolesDrawerType.View) {
      let roleName = '';
      if (props.currentRecord) {
        roleName = props.currentRecord.roleName;
        if (props.currentRecord.type !== RbacRoleType.Custom) {
          roleName = roleName.slice(0, 1).toUpperCase() + roleName.slice(1);
        }
      }
      return roleName;
    }
    if (props.type === RolesDrawerType.Edit) {
      return getFormatMessage('edit_role');
    }
    return getFormatMessage('add_new_role');
  };
  const handleOpenCancel = () => {
    form.resetFields();
    props.onClose();
  };

  const handleSubmit = async () => {
    const values = await form.validateFields();
    if (!values.Name) {
      return messageWarning(getFormatMessage('please_enter_role_name'));
    }
    if (checkedKeys.length === 0) {
      return messageWarning(getFormatMessage('please_select_access_rights'));
    }
    setLoading(true);
    try {
      const trimmedName = values.Name.trim();
      const userList = props.currentRecord?.userList || [];
      const newCheckedKeys: string[] = [];
      checkedKeys.forEach((item) => {
        if (item) {
          newCheckedKeys.push(item);
        }
      });
      const valuesForm = {
        name: trimmedName,
        description: values.Description || '',
        permissions: newCheckedKeys,
        studioID: props.studioId,
        userList,
      };

      if (props.type === RolesDrawerType.Create) {
        const createValues = {
          ...valuesForm,
          type: RbacRoleType.Custom,
        };
        const res = await createRoles(createValues);
        auditWriteLog(IAuditItem.AddNewOrganizationRole, {
          detail: {
            ...valuesForm,
            type: RbacRoleType.Custom,
          },
        });
        if (res) {
          messageSuccess(getFormatMessage('create_success'));
          props.onUpdate();
          props.onClose();
          return;
        }
        messageError(getFormatMessage('create_fail'));
      } else if (
        props.type === RolesDrawerType.Edit &&
        props.currentRecord?.roleId
      ) {
        const res = await editRoles(props.currentRecord.roleId, valuesForm);
        auditWriteLog(IAuditItem.EditOrganizationRole, {
          detail: {
            roleId: props.currentRecord.roleId,
            ...valuesForm,
          },
        });
        if (res) {
          messageSuccess(getFormatMessage('edit_success'));
          props.onUpdate();
          props.onClose();
          return;
        }
        messageError(getFormatMessage('error_update'));
      }
    } catch (error: any) {
      messageError(
        error?.apiError?.message || getFormatMessage('failed_submit')
      );
      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      props.type === RolesDrawerType.Edit ||
      props.type === RolesDrawerType.View
    ) {
      form.setFieldsValue({
        Name: props.currentRecord?.roleName || '',
        Description: props.currentRecord?.desc || '',
      });
      const currentPermissions = Object.assign(
        [],
        props.currentRecord?.permissions
      );
      setCheckedKeys(currentPermissions || []);
    }
    setInit(true);
  }, [props.type]);

  const renderFormItems = () => {
    const disabled = props.type === RolesDrawerType.View;
    let desc = '';
    if (props.currentRecord && disabled) {
      if (props.currentRecord.type === RbacRoleType.Owner) {
        desc = getFormatMessage('role_owner_desc');
      } else if (props.currentRecord.type === RbacRoleType.Admin) {
        desc = getFormatMessage('role_admin_desc');
      } else if (props.currentRecord.type === RbacRoleType.Editor) {
        desc = getFormatMessage('role_editor_desc');
      } else if (props.currentRecord.type === RbacRoleType.Viewer) {
        desc = getFormatMessage('role_viewer_desc');
      } else {
        desc = props.currentRecord.desc;
      }
    }
    return (
      <div className="role-drawer">
        {disabled ? (
          <div>
            <div className="role-drawer-view-title">
              {getFormatMessage('description')}
            </div>
            <div className="role-drawer-view-content">{desc}</div>
          </div>
        ) : (
          <div className="drawer-download-text">
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="Name"
                  label={
                    <div>
                      {getFormatMessage('role_name')}{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </div>
                  }
                  // rules={[{ required: true }]}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    placeholder={getFormatMessage('enter_name_of_role')}
                    onChange={getIsDisabled}
                    style={{ minHeight: '32px' }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="Description"
                  label={getFormatMessage('description')}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input.TextArea
                    placeholder={getFormatMessage('enter_the_role_description')}
                    style={{ minHeight: '66px' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        )}
        <div
          className={classNames(
            'drawer-download-h role-access-rights',
            props.type === RolesDrawerType.View ? 'role-drawer-view-title' : ''
          )}
        >
          {getFormatMessage('access_rights')}
          {props.type !== RolesDrawerType.View && (
            <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
          )}
        </div>
        {props.permissionsList && (
          <AccessRights
            data={props.permissionsList}
            checkedKeys={checkedKeys}
            setCheckedKeys={setCheckedKeys}
            disabled={disabled}
            type={props.currentRecord?.type || null}
            menus={menus}
          />
        )}
      </div>
    );
  };

  useEffect(() => {
    getIsDisabled();
  }, [checkedKeys]);

  const getIsDisabled = () => {
    const nameValue = form.getFieldValue('Name') || '';
    if (!nameValue.trim() || checkedKeys.length === 0) {
      setIsDisabled(true);
      return;
    }
    setIsDisabled(false);
  };

  if (!init) return null;
  return (
    <Drawer
      onClose={() => props.onClose()}
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{getModalTitle()}</span>
          <img
            src={closeIcon}
            className="sync-close-icon"
            onClick={() => props.onClose()}
          />
        </div>
      }
      placement="right"
      width={720}
      closable={false}
      visible={true}
      headerStyle={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        marginLeft: '3px',
      }}
      footer={
        <div
          style={{
            textAlign: 'left',
          }}
        >
          <button
            className="gc-btn sub-button"
            onClick={handleOpenCancel}
            disabled={loading}
          >
            {getFormatMessage('cancel')}
          </button>
          {props.type !== RolesDrawerType.View ? (
            <Button
              className="gc-btn gc-btn-primary gc-btn-download"
              loading={loading}
              onClick={handleSubmit}
              disabled={isDisabled}
            >
              {getFormatMessage('submit')}
            </Button>
          ) : (
            props.currentRecord?.type === RbacRoleType.Custom && (
              <PermissionCheck
                permissionKey={RbacRoleObjectKey.RoleCreate}
                tipsPlacement="left"
              >
                <button
                  className="gc-btn sub-button role-view-edit-btn"
                  onClick={() => props.setEditType(RolesDrawerType.Edit)}
                  disabled={loading}
                >
                  <div className="role-view-edit">
                    <img src={roleEditIcon} className="role-edit-icon" />
                    <img
                      src={roleEditIconHover}
                      className="role-edit-icon-hover"
                    />
                    {getFormatMessage('edit')}
                  </div>
                </button>
              </PermissionCheck>
            )
          )}
        </div>
      }
    >
      <Form form={form}>{renderFormItems()}</Form>
    </Drawer>
  );
};
